import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { Subscriber } from 'shell/models/subscriber';
import { TypeSubscriberClient } from '../list/types';

export interface SubscriberResponse {
  pageInfo:
    | {
        totalCount: number;
        page: number;
        pageSize: number;
      }
    | undefined;
  subscribers: Array<TypeSubscriberClient>;
}

export const transformerSubscriber = (
  response: AxiosResponse<HttpResponseList<Subscriber>>
): SubscriberResponse => {
  const data = response.data.payload?.list || [];
  const pageInfo = response.data.payload?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    subscribers: data.map((event: Subscriber) => ({
      id: event?.codice,
      code: event?.codice.toString(),
      description: event?.descrizione,
    })),
  };
};
